import React from 'react';
import { History } from 'history';
import { Form } from '../../components';
import Model from './user-model';  //editable..
import EventPicklistCard from '../event/event-picklistcard.component';

interface IProps { 
    history: History;
}

interface IState {
    dataRow: Model;
}

export default class UserAuthActivity extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);
        this.state = {
            dataRow: Model.defaultValue()
        }
    }

    private onLoadEvent = (data: any) => {
        this.props.history.push('/event', {id: data.id});
    }

    render() {
        return (
            <Form history={this.props.history} caption='User Activities' buttonCaption=' ' >      
                <EventPicklistCard history={this.props.history} caption='Events' onLoad={this.onLoadEvent} disableBackButton disableCard/>
            </Form>
        )
    }
}